import request from './request';

/**
 * 模型对比API
 */

// 获取计划列表
export function getComparisonPlans(params) {
  return request({ url: '/eval/model-comparison', method: 'get', params });
}

// 获取计划详情
export function getComparisonPlanDetail(id) {
  return request({ url: `/eval/model-comparison/${id}`, method: 'get' });
}

// 创建计划
export function createComparisonPlan(data) {
  return request({ url: '/eval/model-comparison', method: 'post', data });
}

// 更新计划
export function updateComparisonPlan(id, data) {
  return request({ url: `/eval/model-comparison/${id}`, method: 'put', data });
}

// 删除计划
export function deleteComparisonPlan(id) {
  return request({ url: `/eval/model-comparison/${id}`, method: 'delete' });
}

// 添加被测模型
export function addComparisonModel(planId, data) {
  return request({ url: `/eval/model-comparison/${planId}/models`, method: 'post', data });
}

// 移除被测模型
export function removeComparisonModel(planId, modelId) {
  return request({ url: `/eval/model-comparison/${planId}/models/${modelId}`, method: 'delete' });
}

// 添加测试用例
export function addComparisonCase(planId, data) {
  return request({ url: `/eval/model-comparison/${planId}/cases`, method: 'post', data });
}

// 更新用例期望描述
export function updateComparisonCase(planId, caseId, data) {
  return request({ url: `/eval/model-comparison/${planId}/cases/${caseId}`, method: 'put', data });
}

// 移除测试用例
export function removeComparisonCase(planId, caseId) {
  return request({ url: `/eval/model-comparison/${planId}/cases/${caseId}`, method: 'delete' });
}

// 执行计划
export function executeComparisonPlan(id) {
  return request({ url: `/eval/model-comparison/${id}/execute`, method: 'post' });
}

// 获取结果矩阵（execution_no 为空时返回所有批次聚合）
export function getComparisonResults(id, executionNo) {
  const params = executionNo ? { execution_no: executionNo } : {};
  return request({ url: `/eval/model-comparison/${id}/results`, method: 'get', params });
}

// 获取执行进度（轻量轮询专用）
export function getComparisonProgress(id) {
  return request({ url: `/eval/model-comparison/${id}/progress`, method: 'get' });
}

// 获取执行日志分页摘要；全文通过单条详情接口按需加载
export function getComparisonRunLogs(id, executionNo, { current = 1, pageSize = 20 } = {}) {
  const params = { page: current, pageSize };
  if (executionNo) params.execution_no = executionNo;
  return request({ url: `/eval/model-comparison/${id}/run-logs`, method: 'get', params });
}

// 获取单条执行日志全文（提示词、模型响应、裁判理由）
export function getComparisonRunLogDetail(planId, logId) {
  return request({ url: `/eval/model-comparison/${planId}/run-logs/${logId}`, method: 'get' });
}

// 获取结果矩阵单元格的逐轮全文明细
export function getComparisonResultDetail(planId, { executionNo, testCaseId, modelId }) {
  const params = { test_case_id: testCaseId, model_id: modelId };
  if (executionNo) params.execution_no = executionNo;
  return request({ url: `/eval/model-comparison/${planId}/results/detail`, method: 'get', params });
}

// 批量导入 CSV 用例
export function importCsvCases(planId, rows) {
  return request({ url: `/eval/model-comparison/${planId}/import-csv-cases`, method: 'post', data: { rows } });
}

// 取消正在执行的计划
export function cancelComparisonPlan(id) {
  return request({ url: `/eval/model-comparison/${id}/cancel`, method: 'post' });
}

// 生成 AI 叙述性总结
export function generateComparisonSummary(planId, executionNo) {
  return request({
    url: `/eval/model-comparison/${planId}/ai-summary`,
    method: 'post',
    data: executionNo ? { execution_no: executionNo } : {}
  });
}
